"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var withCache = function withCache() {
  var cache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    var Cacheable = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(Cacheable, _Component);

      function Cacheable(props) {
        var _this;

        (0, _classCallCheck2.default)(this, Cacheable);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Cacheable).call(this, props));
        _this.cache = cache;
        _this.updateCache = _this.updateCache.bind((0, _assertThisInitialized2.default)(_this));
        return _this;
      }

      (0, _createClass2.default)(Cacheable, [{
        key: "updateCache",
        value: function updateCache(key, object) {
          // spread existing value to allow for updating single key without
          // passing whole object
          this.cache[key] = Object.assign({}, this.cache[key], {}, object);
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(WrappedComponent, Object.assign({}, this.props, {
            cache: this.cache,
            updateCache: this.updateCache
          }));
        }
      }]);
      return Cacheable;
    }(_react.Component);

    Cacheable.displayName = "Cacheable(" + getDisplayName(WrappedComponent) + ")";
    return Cacheable;
  };
};

var _default = withCache;
exports.default = _default;
module.exports = exports.default;